module.exports = __webpack_public_path__ + "static/media/tower-of-babel-bruegel-the-elder.c3cebbff.jpg";